import React from "react";
import app_image from '../../assets/app-screenshot.png';

export default function WhatWeDo() {
    return (
        <section className="py-12 text-center max-w-[1100px] mx-auto">
            <h2 className="text-5xl font-bold mb-12">What we do</h2>
            <div className="flex flex-col lg:flex-row items-center justify-center gap-16">
                <div>
                    <img src={app_image} alt="What We Do" className="mx-auto mb-8 max-w-[600px]" />
                </div>
                <div className="flex flex-col gap-12 px-8">
                    <div className="text-left"> 
                        <h3 className="text-4xl font-bold mb-5">AI Grant Writer</h3>
                        <p className="mt-2 text-gray-600">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eget viverra risus. Curabitur vitae interdum nisi.
                            In tincidunt eget quam ut ultrices. Pellentesque ullamcorper suscipit sapien.............
                        </p>
                        <button className="mt-10 px-4 py-2 bg-primary text-white rounded">Learn more</button>
                    </div>
                </div>
            </div>
            <div className="flex flex-col lg:flex-row items-center justify-center gap-16">
                <div className="text-left">
                    <h3 className="text-4xl font-bold mb-5">Grant Discovery</h3>
                    <p className="mt-2 text-gray-600">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eget viverra risus. Curabitur vitae interdum nisi.
                        In tincidunt eget quam ut ultrices. Pellentesque ullamcorper suscipit sapien.............
                    </p>
                    <button className="mt-10 px-4 py-2 bg-primary text-white rounded">Learn more</button>
                </div>
                <div>
                    <img src={app_image} alt="What We Do" className="mx-auto mb-8 max-w-[600px]" />
                </div>
            </div>
        </section>
    );
}
